module.exports = __webpack_public_path__ + "static/11-55b11cc9084bc9341c077d4d941ec80e.jpg";